import React, { FC, useEffect, useRef, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Snackbar } from '@mui/material';
import { autoReloadToNewVersion, getNewBuildId, startVersionWatch, subscribeToNewVersion } from 'utils/app-version';

// DD-3742: once a new build is out, tell the user and move the tab onto it at the next page
// change, where nothing half-filled is lost. Query-string changes (filters, tabs within a page)
// do not count as a page change.
const AppVersionWatcher: FC = () => {
    const { t: translate } = useTranslation('common');
    const { pathname } = useLocation();
    const previousPathname = useRef(pathname);
    const newBuildId = useSyncExternalStore(subscribeToNewVersion, getNewBuildId);

    useEffect(() => startVersionWatch(), []);

    useEffect(() => {
        if (previousPathname.current === pathname) return;
        previousPathname.current = pathname;
        autoReloadToNewVersion();
    }, [pathname]);

    return (
        <Snackbar open={!!newBuildId} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert
                severity="info"
                variant="filled"
                action={
                    <Button
                        color="inherit"
                        size="small"
                        onClick={() => window.location.reload()}
                        data-test="app-version-watcher.reload-button"
                    >
                        {translate('NEW_VERSION_RELOAD')}
                    </Button>
                }
            >
                {translate('NEW_VERSION_AVAILABLE')}
            </Alert>
        </Snackbar>
    );
};

export default AppVersionWatcher;
